import { observer } from 'mobx-react'
import { useEffect, useRef, useState } from 'react'
import { TrackingFlag } from '../../tracking/TrackingContent'
import { ReactComponent as Arrow } from '../../../../assets/login/Rectangle 30.svg'
import classNames from 'classnames'
import IMask from 'imask'
import './index.scss'
import CountrySelect from '../../login/CountrySelect'
import GlobalState from '../../../../stores/GlobalState'
import { CountriesStore } from '../CoopPop'

const PhoneInput = observer(
  ({
    state,
    placeholder,
    error,
    setValue,
  }: {
    state: string
    placeholder: string
    error: string
    setValue: (value: any) => void
  }) => {
    const mask = useRef<any>(null)
    const inputRef = useRef<any>(null)
    const [country, setCountry] = useState({
      country: GlobalState.currentLocale.lang.includes('En')
        ? 'Ukraine'
        : GlobalState.currentLocale.lang.includes('ру')
        ? 'Украина'
        : 'Україна',
      number: '+380',
      flag: '',
    })
    const [phone, setPhone] = useState('')
    const [show, setShow] = useState(false)
    useEffect(() => {
      if (!inputRef.current) return
      const maskOptions = {
        mask: '00-000-00-00[-00]',
      }
      mask.current = IMask(inputRef.current, maskOptions)
        .on('accept', () => {
          //setValue(country.number + mask.current.value)
          mask.current.updateValue()
        })
        .on('complete', () => {
          setValue(country.number + mask.current.value)
          mask.current.updateValue()
        })

      return () => {
        mask.current.destroy()
      }
    }, [country, phone])

    const getFlag = (name: string) => {
      let res: any = null
      CountriesStore.list?.uk?.forEach((e: any) => {
        if (e.country.toLocaleLowerCase().includes(name.toLocaleLowerCase())) {
          res = e
          return
        }
      })

      if (!res) {
        CountriesStore.list?.en?.forEach((e: any) => {
          if (
            e.country.toLocaleLowerCase().includes(name.toLocaleLowerCase())
          ) {
            res = e
            return
          }
        })
      }
      if (!res) {
        CountriesStore.list?.ru?.forEach((e: any) => {
          if (
            e.country.toLocaleLowerCase().includes(name.toLocaleLowerCase())
          ) {
            res = e
            return
          }
        })
      }

      return res?.flag || ''
    }

    useEffect(() => {
      setCountry({ ...country, flag: getFlag(country.country) })
    }, [CountriesStore.list])

    return (
      <>
        {!show ? (
          <div className="phone-input">
            <div
              className={classNames(
                'phone-input__number',
                mask.current?.value?.length && 'fill',
                error && 'error',
              )}
              onClick={() => setShow(true)}
            >
              <div className="phone-input__number-icon">
                <img src={country.flag || ''} />
              </div>
              <span className="phone-input__number-text">{country.number}</span>
              <Arrow />
            </div>
            <input
              ref={inputRef}
              className={classNames(
                'phone-input__input',
                error && 'error',
                mask.current?.value?.length && 'fill',
              )}
              value={mask.current?.value || ''}
              placeholder={placeholder}
              onChange={(e) => {
                setPhone(e.target.value)
                mask.current.updateValue()
              }}
            />
          </div>
        ) : (
          <CountrySelect
            setState={(value) => {
              if (!value) {
                setShow(false)
                return
              } else setCountry(value)
              setShow(false)
            }}
          />
        )}
      </>
    )
  },
)

export default PhoneInput
